var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"stickyWrapper",staticClass:"sticky-wrapper"},[_c('div',{ref:"stickyContent",staticClass:"sticky-content",class:{ 'is-sticky': _vm.isSticky },style:(_vm.stickyStyles)},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }